import { JSONSchema7 } from 'json-schema';
import { types as commonTypes, customSchemas } from '@sitebuilder/common';
import IconIndicator from './IconIndicator';

const schema: JSONSchema7 = {
    title: 'IconIndicator',
    type: 'object',
    required: ['dataKey', 'activeIconName', 'inactiveIconName'],
    properties: {
        styles: {
            type: 'string',
            description: 'A stylesheet',
            default: '',
        },
        ...customSchemas.textSchema.TextSchema.schema,
        ...customSchemas.styleSchema.StyleSchema.schema,
        ...customSchemas.layoutSchema.LayoutSchema.schema,
        activeIconName: {
            type: 'string',
            title: 'Active Icon Name',
            default: '',
        },
        inactiveIconName: {
            type: 'string',
            title: 'Inactive Icon Name',
            default: '',
        },
        dataKey: {
            type: 'string',
            title: 'Data Key',
            default: '',
        },
        altText: {
            type: 'string',
            title: 'Alternative Text',
            default: '',
        },
        noDataMessage: {
            type: 'string',
            title: 'Text to show when no data',
        },
        isTransformData: {
            type: 'boolean',
            title: 'Is Transform Data',
            default: false,
        },
    },
    dependencies: {
        isTransformData: {
            oneOf: [
                {
                    properties: {
                        isTransformData: { enum: [true] },
                        functionToTransform: {
                            type: 'string',
                            description: 'Function to transform',
                            default: 'return (data) => { return data}',
                        },
                    },
                },
                {
                    properties: {
                        isTransformData: { enum: [false] },
                    },
                },
            ],
        },
        ...customSchemas.layoutSchema.LayoutSchema.dependencies,
    },
};

const groups = [
    {
        'Style Editor': ['styles'],
        ...customSchemas.textSchema.TextSchema.group,
        ...customSchemas.styleSchema.StyleSchema.group,
        ...customSchemas.layoutSchema.LayoutSchema.group,
        Values: ['activeIconName', 'inactiveIconName', 'dataKey', 'altText', 'noDataMessage'],
        'Transform Data': ['isTransformData', 'functionToTransform'],
    },
];

const uiSchema = {
    'ui:groups': groups,
    styles: {
        'ui:widget': 'CSSEditor',
    },
    ...customSchemas.textSchema.TextSchema.uiSchema,
    ...customSchemas.styleSchema.StyleSchema.uiSchema,
    ...customSchemas.layoutSchema.LayoutSchema.uiSchema,
    activeIconName: {
        'ui:placeholder': 'fas fa-star',
        'ui:widget': 'ResourcePicker',
    },
    inactiveIconName: {
        'ui:placeholder': 'far fa-star',
        'ui:widget': 'ResourcePicker',
    },
    altText: {
        'ui:widget': 'ResourcePicker',
    },
    dataKey: {
        'ui:widget': 'ResourcePicker',
    },
    noDataMessage: {
        'ui:widget': 'ResourcePicker',
    },
    functionToTransform: { 'ui:widget': 'JSEditor' },
};

const IconIndicatorWidget: commonTypes.IWidget = {
    schema,
    uiSchema,
    templateView: IconIndicator,
    id: 'IconIndicator',
    group: 'component',
    contentPlaceHolders: ['children'],
    initialData: () => ({
        dataKey: '',
        activeIconName: 'fas fa-star',
        inactiveIconName: 'far fa-star',
    }),
};

export default IconIndicatorWidget;
